export var SimpleFormIteratorPrefix = 'RaSimpleFormIterator';
export var SimpleFormIteratorClasses = {
    line: "".concat(SimpleFormIteratorPrefix, "-line"),
    index: "".concat(SimpleFormIteratorPrefix, "-index"),
    indexContainer: "".concat(SimpleFormIteratorPrefix, "-indexContainer"),
    form: "".concat(SimpleFormIteratorPrefix, "-form"),
    action: "".concat(SimpleFormIteratorPrefix, "-action"),
    leftIcon: "".concat(SimpleFormIteratorPrefix, "-leftIcon"),
};
